import axios from "axios";
import { authenticatedApiConfig } from "./BaseApiService";
export class SnomedService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getSnomeds(descriptionPrefix, limit) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/snomeds?descriptionPrefix=${descriptionPrefix}&limit=${limit}`, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getSnomed(code) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/snomeds/${code}`, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getSnomedParents(code) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/snomeds/${code}/parents`, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getSnomedDescendants(code) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/snomeds/${code}/descendants`, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getSnomedDescriptions(code) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/snomeds/${code}/descriptions`, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
}
